module.exports = __webpack_public_path__ + "img/mango_sliced.ee45b272.jpg";